import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoData } from './config';

function appendMeta(attribute, key, content) {
  const meta = document.createElement('meta');
  meta.setAttribute(attribute, key);
  meta.setAttribute('content', content);
  meta.setAttribute('data-seo-dynamic', 'true');
  document.head.appendChild(meta);
}

function appendLink(rel, href, hreflang) {
  const link = document.createElement('link');
  link.setAttribute('rel', rel);
  link.setAttribute('href', href);
  if (hreflang) {
    link.setAttribute('hreflang', hreflang);
  }
  link.setAttribute('data-seo-dynamic', 'true');
  document.head.appendChild(link);
}

export default function Seo() {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoData(location.pathname);

    document.head.querySelectorAll('[data-seo-dynamic]').forEach((node) => node.remove());
    document.documentElement.lang = seo.htmlLang;
    document.title = seo.title;

    appendMeta('name', 'description', seo.description);
    appendMeta('name', 'robots', seo.robots);
    appendMeta('property', 'og:type', 'website');
    appendMeta('property', 'og:site_name', 'AgroLlama');
    appendMeta('property', 'og:locale', seo.ogLocale);
    appendMeta('property', 'og:url', seo.canonical);
    appendMeta('property', 'og:title', seo.title);
    appendMeta('property', 'og:description', seo.description);
    appendMeta('property', 'og:image', seo.image);
    appendMeta('property', 'og:image:width', String(seo.imageWidth));
    appendMeta('property', 'og:image:height', String(seo.imageHeight));
    appendMeta('property', 'og:image:alt', seo.imageAlt);
    appendMeta('name', 'twitter:card', 'summary_large_image');
    appendMeta('name', 'twitter:title', seo.title);
    appendMeta('name', 'twitter:description', seo.description);
    appendMeta('name', 'twitter:image', seo.image);
    appendMeta('name', 'twitter:image:alt', seo.imageAlt);

    appendLink('canonical', seo.canonical);
    seo.alternates.forEach((alternate) => {
      appendLink('alternate', alternate.href, alternate.hreflang);
    });

    const structuredData = document.createElement('script');
    structuredData.type = 'application/ld+json';
    structuredData.setAttribute('data-seo-dynamic', 'true');
    structuredData.textContent = JSON.stringify(seo.structuredData);
    document.head.appendChild(structuredData);
  }, [location.pathname]);

  return null;
}
